/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { createMagneticFluxQuantum } from '../../factoriesAny.js';
export var magneticFluxQuantumDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  UnitDependencies: UnitDependencies,
  createMagneticFluxQuantum: createMagneticFluxQuantum
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMagneticFluxQuantum.generated.js
// module id = 1449
// module chunks = 0